import React from "react";
import { useHistory } from "react-router-dom";
import { useJobSeekerSubscription, useActiveCampaign } from "../../hooks/queries";
import "./index.css";

const JobMatchScoreWidget = () => {
  const history = useHistory();
  const { data: subscription } = useJobSeekerSubscription();
  const { data: campaign } = useActiveCampaign();

  const credits = subscription?.credits_remaining ?? null;

  const handleClick = () => {
    history.push("/job-match-score");
  };

  return (
    <div className="job-match-widget" onClick={handleClick}>
      <div className="jmw-header">
        <div className="jmw-icon-circle">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <circle cx="12" cy="12" r="6"/>
            <circle cx="12" cy="12" r="2"/>
          </svg>
        </div>
        <div className="jmw-header-text">
          <h3 className="jmw-title">Job Match Score</h3>
          <span className="jmw-subtitle">AI-Powered Analysis</span>
        </div>
      </div>
      
      <p className="jmw-description">
        Compare your CV against any job posting and get instant AI-powered match scores with detailed insights.
      </p>

      {campaign && (
        <div className="jmw-campaign-badge">
          <span>🎁</span>
          <span>{campaign.credits} Free Scans Available!</span>
        </div>
      )}

      <div className="jmw-features">
        <div className="jmw-feature">
          <span className="jmw-feature-icon">✓</span>
          <span className="jmw-feature-text">Instant match percentage</span>
        </div>
        <div className="jmw-feature">
          <span className="jmw-feature-icon">✓</span>
          <span className="jmw-feature-text">Skills gap analysis</span>
        </div>
        <div className="jmw-feature">
          <span className="jmw-feature-icon">✓</span>
          <span className="jmw-feature-text">Personalized recommendations</span>
        </div>
      </div>

      <div className="jmw-cta">
        <span className="jmw-cta-text">
          {credits > 0
            ? `Try Job Match Score (${credits} credit${credits === 1 ? "" : "s"})`
            : "Try Job Match Score"}
        </span>
        <svg className="jmw-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </div>
    </div>
  );
};

export default JobMatchScoreWidget;
